import { RootState } from '@redux/store';

export const getActionsByTypeProduct = (state: RootState) => state.actions.listByTypeProduct;
